module.exports = __webpack_public_path__ + "fonts/ropa-sans-v9-latin-ext_latin-regular.woff?3fa8627c8b90f3e6b3fc188a55ead92e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ropa-sans-v9-latin-ext_latin-regular.woff
// module id = 315
// module chunks = 0